var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("h1", { staticClass: "irismedium" }, [
        _vm._v(_vm._s(_vm.$t("common.appname"))),
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "mdi mdi-electron-framework" }),
        _vm._v(
          "\n            " + _vm._s(_vm.$t("pages.about.name")) + ".\n        "
        ),
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v("\n            JLL"),
        _c("sup", [_vm._v("©")]),
        _vm._v(" - "),
        _c("span", { staticClass: "irismedium" }, [_vm._v("L.D.D.")]),
        _vm._v(
          " Legal &\n            Digital Products Department Collaboration " +
            _vm._s(_vm.year) +
            "\n        "
        ),
      ]),
      _vm._v(" "),
      _c("br"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }